import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PdfTableComponent } from './pdf-table.component';
import { PdfSpacerModule } from '../pdf-spacer/pdf-spacer.module';


@NgModule({
  declarations: [
    PdfTableComponent
  ],
  exports: [
    PdfTableComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PdfSpacerModule
  ],
  providers: []
})
export class PdfTableModule { }
